"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var utilities_1 = require("./utilities");
var lodash_1 = require("lodash");
var SisControlWithSettings = /** @class */ (function () {
    function SisControlWithSettings() {
    }
    Object.defineProperty(SisControlWithSettings.prototype, "hint", {
        get: function () {
            return this._hint;
        },
        set: function (multilingualString) {
            if (multilingualString instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
                this._hint = multilingualString;
            }
            else if (lodash_1.isPlainObject(multilingualString)) {
                var builder_1 = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
                lodash_1.entries(multilingualString).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    builder_1.withValueForLanguage(lodash_1.parseInt(key, 10), value);
                });
                this._hint = builder_1.build();
            }
            else if (multilingualString) {
                this._hint = utilities_1.stringToMultilingual(multilingualString);
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisControlWithSettings.prototype, "hint", null);
    return SisControlWithSettings;
}());
exports.SisControlWithSettings = SisControlWithSettings;
//# sourceMappingURL=sis-control-with-settings.js.map